var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBalloon = function SvgBalloon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    fillOpacity: 0.3,
    d: "m16.22 15.97.23.239c-.91.87-1.243 1.753-.745 2.727.612 1.198.488 1.953-.343 2.946l-.254-.213c.749-.895.85-1.509.301-2.583-.579-1.132-.191-2.157.81-3.117Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    fillOpacity: 0.3,
    d: "M14.798 15.549s-1.238.494-.557.752c.681.259 3.902.035 3.627-.445-.276-.48-.936-.57-.936-.57s10.672-5.672 3.671-12.425c-7.09-6.84-18.152 7.36-5.805 12.688Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    d: "M12.777 17.774c-.67.346-1.344.602-1.68.596-.874-.017.074-1.217.074-1.217C-5.101 16.023-.258-3.382 10.064 1.935c7.784 4.01 3.13 13.903 3.13 13.903s.741-.188 1.344.297c.311.25-.38.84-1.243 1.352 1.476 1.014 1.868 1.504 1.979 2.513.036.328.02.593-.048 1.19-.123 1.077-.076 1.5.332 1.917l-.378.37c-.56-.572-.62-1.116-.48-2.346.063-.557.078-.798.048-1.073-.094-.856-.437-1.25-1.971-2.284Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBalloon);
export default ForwardRef;